<template>
    <div>
        <div style="display: flex; justify-content: center; align-items: center; margin: inherit">
            <img v-show="loading" style="width: 50px" :src="src_loading" />
        </div>
        <div
            v-for="(page, index) in quote_template_devis"
            :key="`page-${index}`"
            class="pos_card draggable-item"
            draggable="true"
            @dragstart="dragStart(index)"
            @dragover.prevent
            @drop="drop(index)"
        >
            <div
                :class="[
                    ...(page.isVisible
                        ? ['card-body', 'pos_title_page', 'cardVisible']
                        : ['card-body', 'pos_title_page', 'card']),
                ]"
            >
                <div :class="'title_page_style_show title_page_black uppercaseFirstLetter poppinsSemiBold'">
                    {{ page.title_page }}
                </div>
                <div class="pos_button_page_right">
                    <button
                        v-show="!page.isVisible && canModifyModelDevis"
                        type="button"
                        @click="cloner(index)"
                        class="btn btn_eyes"
                    >
                        <i class="fa-solid fa-copy text-black"></i>
                    </button>
                    <button v-show="!page.isVisible && page.cloned" type="button" @click="removePage(index)" class="btn btn_eyes">
                        <i class="fa-solid fa-trash text-black"></i>
                    </button>
                    <button type="button" @click="open_popup(index)" class="btn btn_eyes img_eyes"></button>
                    <button
                        type="button"
                        @click="toggleVisibility(index)"
                        class="btn btn_eyes"
                        :class="[!page.isVisible ? 'chevron-down' : 'chevron-up']"
                    ></button>
                </div>
            </div>
            <div v-show="page.isVisible" class="border_layout_content_page pt-3 border-top-0">
                <div class="row pb-6">
                    <div v-if="page.title_page != 'Devis'" class="col-lg-4 col-xs-12 col-md-4">
                        <ImageUpload
                            v-show="page.title_page === 'Page de garde' || page.title_page === 'Page de fin'"
                            :has_logo="1"
                            :index="index"
                            :info_page="page"
                            :isSubmitting="isSubmitting"
                            @image-uploaded="updateImage"
                        />
                        <ImageUpload
                            :has_bg="1"
                            @disable-button="disableButton"
                            @enable-button="enableButton"
                            :index="index"
                            :info_page="page"
                            :isSubmitting="isSubmitting"
                            @image-uploaded="updateImage"
                        />

                        <Color
                            :has_shap_1="1"
                            :index="index"
                            :info_page="page"
                            @color-uploaded="colorUploaded"
                            :colors="colors"
                        />
                        <Color
                            v-show="page.title_page === 'Page de garde' || page.title_page === 'Page de fin'"
                            :has_shap_2="1"
                            :index="index"
                            :info_page="page"
                            :colors="colors"
                            @color-uploaded="colorUploaded"
                        />
                    </div>

                    <div v-if="page.title_page == 'Devis'" class="col-lg-8 col-xs-12"></div>

                    <div class="col-lg-8 col-xs-12 col-md-6 mx-auto">
                        <div v-show="page.render_html" class="preview-container overflow-y-auto rounded-md">
                            <div :ref="`title_${index}`" v-html="page.title"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Popup :visible="showPopup" :info_page="quote_template_devis[activePopupIndex]" @close="showPopup = false" />
    </div>
</template>
<script>
import Popup from './Popup.vue'
import ImageUpload from './ImageUpload.vue'
import Color from './Color.vue'
export default {
    components: {
        Popup,
        ImageUpload,
        Color,
    },
    props: ['data', 'template_id', 'canModifyModelDevis'],
    data() {
        return {
            quote_template_devis: [],
            bloc_image_eye: window.location.origin + '/media/bo/icons/eye.png',
            editorInstances: {},
            isSubmitting: false,
            errors: [],
            draggedIndex: null,
            showPopup: false,
            activePopupIndex: null,
            colors: [],
            src_loading: window.location.origin + '/media/bo/icons/loading.gif',
            loading: false,
        }
    },

    methods: {
        cloner(index) {
            const newPage = {
                title: this.quote_template_devis[index].title,
                title_page: this.quote_template_devis[index].title_page,
                description: this.quote_template_devis[index].description,
                image: this.quote_template_devis[index].image,
                editorId: `editor-${Date.now()}`,
                isVisible: this.quote_template_devis[index].isVisible,
                render_html: this.quote_template_devis[index].render_html,
                tmp_image: this.quote_template_devis[index].tmp_image,
                cloned: 1,
            }
            //this.quote_template_devis.push(newPage);
            this.quote_template_devis.splice(index + 1, 0, newPage)
        },
        open_popup(index) {
            this.handleEdit(index)
            this.activePopupIndex = index
            this.showPopup = true
        },
        dragStart(index) {
            this.draggedIndex = index
        },
        drop(index) {
            const draggedItem = this.quote_template_devis[this.draggedIndex]
            this.quote_template_devis.splice(this.draggedIndex, 1)
            this.quote_template_devis.splice(index, 0, draggedItem)
        },
        handleSelectAttributesClose() {},
        closeAll() {
            this.quote_template_devis = this.quote_template_devis.map(({ page, ...rest }, index) => {
                this.handleEdit(index) // call your method
                return {
                    ...rest,
                    isVisible: 0,
                    readonly: false,
                }
            })
        },
        addPage() {
            const newPage = {
                title: '',
                title_page: '',
                description: '',
                image: '',
                editorId: `editor-${Date.now()}`,
                isVisible: 0,
                render_html: 0,
                tmp_image: '',
                cloned: 0,
            }

            this.quote_template_devis.push(newPage)
        },
        toggleVisibility(index) {
            this.quote_template_devis[index].isVisible = this.quote_template_devis[index].isVisible == 0 ? 1 : 0
            this.handleEdit(index)
        },
        handleSubmit(template_id) {
            this.isSubmitting = true
            this.closeAll()
            setTimeout(() => {
                this.storeSettingEstimate(template_id)
            }, 1000)
        },
        handleEdit(index) {
            this.$nextTick(() => {
                const el = this.$refs[`title_${index}`][0]
                if (el) {
                    this.quote_template_devis[index].title = el.innerHTML
                } else {
                    console.warn(`Element title_${index} not found`)
                }
            })
        },
        scrollToFirstError() {
            const firstErrorElement = document.querySelector('.is-invalid')
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        },
        async storeSettingEstimate(template_id) {
            const formData = new FormData()
            this.quote_template_devis.forEach((page, index) => {
                formData.append(`quote_template_devis[${index}][description]`, page.description)
                formData.append(`quote_template_devis[${index}][title]`, page.title)
                formData.append(`quote_template_devis[${index}][image]`, page.image)
                formData.append(`quote_template_devis[${index}][render_html]`, page.render_html)
                formData.append(`quote_template_devis[${index}][isVisible]`, page.isVisible)
                formData.append(`quote_template_devis[${index}][title_page]`, page.title_page)
                formData.append(`quote_template_devis[${index}][cloned]`, page.cloned)
                // Handle image files if needed
            })
            formData.append(`template_id`, template_id)

            axios
                .post('/back-office/gestion/template/devis', formData)
                .then((response) => {
                    this.showMessageNotification(response.data.message, 'success')
                    this.isSubmitting = false
                    this.fetchData(template_id)
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        // Validation error - display messages to user
                        const errors = error.response.data.errors
                        let errorMessages = []

                        // Collect all error messages
                        for (const field in errors) {
                            errorMessages.push(...errors[field])
                        }

                        // Show all error messages
                        this.showMessageNotification(errorMessages.join('<br>'), 'error')

                        // Alternatively, you could handle each field's error individually
                        // by setting error states for each form field
                    }
                    this.isSubmitting = false
                })
        },
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        async generateIA(template_id) {
            this.loading = true
            this.$emit('disable-button')
            try {
                const response = await axios.get('/back-office/generate_page/' + template_id)
                if (response.status === 200) {
                    this.fetchData(template_id)
                    this.loading = false
                    this.$emit('enable-button') // tell parent to enable
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                throw error
            }
        },
        async fetchData(template_id) {
            console.log('template_id', template_id)
            try {
                const response = await axios.get('/back-office/gestion/template/devis/show/' + template_id)
                if (response.data.colors) {
                    this.colors = response.data.colors
                }
                if (response.data.template_devis) {
                    this.quote_template_devis = response.data.template_devis.map((page) => ({
                        ...page,
                        tmp_image: '',
                        readonly: true,
                    }))

                    this.quote_template_devis.forEach((page) => {
                        page.editorId = `editor-${Date.now()}-${Math.floor(Math.random() * 1000)}`
                    })
                }

                return response.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.showMessageNotification('Failed to load data', 'error')
                throw error
            }
        },
        removePage(index) {
            const page = this.quote_template_devis[index]
            this.quote_template_devis.splice(index, 1)
        },
        updateImage({ index, image, has_bg }) {
            this.$nextTick(() => {
                const container = this.$refs[`title_${index}`][0]
                let img = ''
                if (container) {
                    if (has_bg == 1) {
                        img = container.querySelector('#bg')
                        this.updateImageStyle(img, this.isSubmitting, image, index)
                    } else {
                        img = container.querySelector('#logo')
                        img.src = image
                    }
                }
                this.handleEdit(index)
            })
        },
        updateImageStyle(image, isLoading, path_img, index) {
            if (!image) return
            const title = this.quote_template_devis[index].title_page
            const heightMap = {
                Présentation: '480px',
                'Mentions légales': '480px',
                'Page de garde': '500px',
                'Page de fin': '520px',
            }

            const height = heightMap[title] || '0px'
            const styles = isLoading
                ? {
                      backgroundImage: `url('${this.src_loading}')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '50px 50px',
                      backgroundPosition: 'center',
                      backgroundOrigin: 'content-box',
                      height: '150px',
                      width: '150px',
                      display: 'table',
                      margin: '0 auto',
                  }
                : {
                      backgroundImage: `url('${path_img}')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: '100% 100%',
                      backgroundPosition: 'center',
                      width: '100%',
                      height: height,
                  }

            Object.assign(image.style, styles)
        },
        colorUploaded({ index, type, color }) {
            const container = this.$refs[`title_${index}`][0]
            if (type == 'has_shap_1') {
                container.querySelector('#shop_one').style.backgroundColor = color
                container.querySelector('#shop_two').style.backgroundColor = color
                container.querySelectorAll('.colorFontOne').forEach((font) => {
                    font.style.color = color
                })
            } else {
                container.querySelectorAll('.colorFontTwo').forEach((font) => {
                    font.style.color = color
                })
            }
            this.handleEdit(index)
        },
        toggle() {
            this.isToggled = !this.isToggled
        },
        stripHtml(html) {
            if (!html) return ''
            return html.replace(/<[^>]*>/g, '') // Supprime toutes les balises
        },
        disableButton() {
            console.log('disable')
            this.$emit('update:isSubmitting', true)
        },
        enableButton() {
            console.log('enable')
            this.$emit('update:isSubmitting', false)
        },
    },
    mounted() {
        this.fetchData(this.template_id)
        if (!document.getElementById('fa-cdn')) {
            const link = document.createElement('link')
            link.id = 'fa-cdn'
            link.rel = 'stylesheet'
            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css'
            document.head.appendChild(link)
        }
    },
}
</script>

<style scoped>
.pos_card {
    margin-left: 0%;
    margin-right: 0%;
    margin-bottom: 25px;
}

.border_layout_content_page {
    height: auto;
    box-shadow: 0px 1px 3px 0px #0000001a;
    border: 1px solid #e2e8f0;
}

.btn_eyes {
    width: 35px;
    height: 35px;
    top: 12px;
    left: 103px;
    background-color: #ffff;
}

.img_eyes {
    background-image: url('/media/bo/icons/eye.png');
    background-size: 15px 15px; /* Adjusts image to cover the entire element */
    background-position: center; /* Centers the image */
    background-repeat: no-repeat;
}

.chevron-up {
    background-image: url('/media/bo/icons/chevron-up.png');
    background-size: auto; /* Adjusts image to cover the entire element */
    background-position: center; /* Centers the image */
    background-repeat: no-repeat;
}

.chevron-down {
    background-image: url('/media/bo/icons/chevron-down.png');
    background-size: auto; /* Adjusts image to cover the entire element */
    background-position: center; /* Centers the image */
    background-repeat: no-repeat;
}

.pos_button_page_right {
    float: right;
}
.title_page_black {
    color: #021832;
}
.uppercaseFirstLetter::first-letter {
    text-transform: uppercase;
}
.title_page_style_show {
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0%;
}
.pos_title_page {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem 1rem 2rem;
    flex-direction: inherit;
}
.card {
    height: 56px;
    background-color: white;
    border: 1px solid #d5d7da;
    border-radius: 8px;
}
.card:hover {
    border: 1px solid #021832;
    background-color: white;
    font-weight: bolder;
}
.cardVisible {
    height: 56px;
    background-color: white;
    border: 1px solid #d5d7da;
    border-bottom: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.cardVisible:hover {
    border: 1px solid #021832;
    background-color: white;
    font-weight: bolder;
    border-bottom: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.cardVisible:hover + .border_layout_content_page {
    border: 1px solid #021832;
}

.btn:hover {
    border: 1px solid #021832 !important;
}
.text-black {
    color: #0000;
}

/* Disabled button styling */
button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.tooltip input,
.tooltip button {
    margin-bottom: 5px;
    display: block;
}

.vs__open-indicator {
    margin-right: 9px;
    fill: #94a3b8;
}
.preview-container {
    width: 95%;
    height: auto;
    top: 78px;
    left: 511px;
    border: 1px solid #7d2dbd;
    box-shadow: 0 4px 4px 0 #00000040;
    border-radius: 15px;
}

@media (max-width: 480px) {
    .btn-up svg {
        width: 24px;
        height: 24px;
    }
}
@media (max-width: 412px) {
    .pos_button_page_right {
        display: ruby;
    }
    svg {
        width: 15px;
        height: 17px;
    }
}
</style>
